const jsonUri = '/?eID=psrsortenfinder_speciesjson';
const loadData = (uri, lang, ce, sourceTarget) => {
	return fetch(uri)
		.then(response => response.json())
		.catch(error => {
			return loadData(jsonUri + '&lang=' + lang + '&ce=' + ce + '&sourceTarget=' + sourceTarget);
			console.error(error)
		})
}

module.exports = {
	loadData
}
